module.exports = __webpack_public_path__ + "img/jqr3.5cf113de.jpg";